"use strict";

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePlaceholder = void 0;

var react_1 = __importDefault(require("react"));

function usePlaceholder(_ref) {
  var placeholder = _ref.placeholder,
      getChildren = _ref.getChildren;
  var isPlaceholderRef = react_1["default"].useRef(true);
  var timeoutRef = react_1["default"].useRef();

  var _react_1$default$useS = react_1["default"].useState(placeholder),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      contents = _react_1$default$useS2[0],
      setContents = _react_1$default$useS2[1];

  react_1["default"].useEffect(function () {
    clearTimeout(timeoutRef.current);

    if (isPlaceholderRef.current) {
      timeoutRef.current = setTimeout(function () {
        setContents(getChildren());
      });
    } else {
      setContents(getChildren());
    }
  }, [getChildren]);
  return contents;
}

exports.usePlaceholder = usePlaceholder;